import { useState } from "react"
import { Button } from "../../../components/Button";
import { SignedUrlImage } from "../../../components/SignedUrlImage";
import { useApp } from "../../../services/app-context";

const TOTAL_STEP = 2;

const getList = (labels: any) => {
    return  [
        {
            title: "Active Listening",
            description: "You make sure interactions are conversational, not a one-sided pitch.",
        },
        {
            title: "Brand Strategy Alignment",
            description: "You know your source material by heart.",
        },
        {
            title: "Response Time",
            description: "You avoid lengthy pauses with prompt but thoughtful responses.",
        },
        {
            title: "Empathy and Personalization",
            description: "You're able to adapt your approach by the AI HCP's personality and role.",
        },
        {
            title: labels?.compliance || "Compliance",
            description: "You maintain ethical and compliant interactions."
        }
    
    ]
}

function BulletPoint({ text, title, isSelected, onSelect }: { text: string; title: string; isSelected: boolean; onSelect: (title: string) => void; }) {
    return (
        <div role="button" onClick={() => onSelect(title)} className={`flex flex-col px-3 py-2 rounded-md border-2 ${isSelected ? "border-PraxisDarkRed !bg-background2" : "bg-[#EFEFEF] border-transparent"}`}>
            <div className="text-[15px] font-medium text-text-primary">{title}</div>
            <div className="text-text-primary text-[11px] font-normal opacity-60">{text}</div>
        </div>
    )
}


function SubStep1({ onContinue }: { onContinue: () => void }) {
    const { tenantProfile } = useApp()
    const [selected, setSelected] = useState<string[]>([]);
    const handleSelect = (title: string) => {
        if (selected.includes(title)) {
            setSelected(prev => prev.filter(item => item !== title));
        } else {
            if (selected.length < 3) {
                setSelected(prev => [...prev, title]);
            }
        }
    }
    return (

        <div className="flex items-start gap-10 pb-10 pt-8 pl-5 pr-5">
            <div className="flex-1 flex justify-center flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <span className="text-black text-[21px] font-bold ">Tell us your strengths:</span>
                </div>
                <p className="text-black text-sm font-normal "><span className="opacity-60">Your answers will help us tailor PraxisPro to your needs. Select up to </span><span className="text-primary italic font-medium !opacity-100">three.</span></p>
                <div className="w-full flex justify-center">
                    <SignedUrlImage s3Key="onboarding-3.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
                </div>
            </div>
            <div className="flex flex-col gap-4 flex-1">
                <div>

                    <div className="flex flex-col gap-1.5">
                        {
                            getList(tenantProfile?.labels || {})?.map((item) => (
                                <BulletPoint
                                    isSelected={selected.includes(item.title)}
                                    title={item.title}
                                    text={item.description}
                                    key={item.title}
                                    onSelect={handleSelect}
                                />
                            ))
                        }

                    </div>
                    <div className="mt-10 flex justify-end">
                        <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}


function SubStep2({ onContinue }: { onContinue: () => void }) {
    const {tenantProfile} = useApp()
    const [selected, setSelected] = useState<string[]>([]);
    const handleSelect = (title: string) => {
        if (selected.includes(title)) {
            setSelected(prev => prev.filter(item => item !== title));
        } else {
            if (selected.length < 3) {
                setSelected(prev => [...prev, title]);
            }
        }
    }
    return (

        <div className="flex items-start gap-10 pb-10 pt-8 pl-5 pr-5">
            <div className="flex-1 flex justify-center flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <span className="text-black text-[21px] font-bold ">Any areas for improvement?</span>
                </div>
                <p className="text-black text-sm font-normal"><span className="opacity-60">Your answers will help us tailor PraxisPro to your needs. Select up to </span><span className="text-primary italic font-medium !opacity-100">three.</span></p>
                <div className="w-full flex justify-center">
                    <SignedUrlImage s3Key="onboarding-3.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
                </div>
            </div>
            <div className="flex flex-col gap-4 flex-1">
                <div>

                    <div className="flex flex-col gap-1.5">
                        {
                            getList(tenantProfile?.labels || {}).map((item) => (
                                <BulletPoint
                                    isSelected={selected.includes(item.title)}
                                    title={item.title}
                                    text={item.description}
                                    key={item.title}
                                    onSelect={handleSelect}
                                />
                            ))
                        }

                    </div>
                    <div className="mt-10 flex justify-end">
                        <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                    </div>
                </div>
            </div>
        </div>
    )

}

const subSteps = {
    1: SubStep1,
    2: SubStep2
}

export function Step4({ onContinue }: { onContinue: () => void }) {
    const [subStep, setSubStep] = useState(1);
    const Component = subSteps[subStep];

    const handleContinue = () => {
        if (subStep < TOTAL_STEP) {
            setSubStep(prev => prev + 1);
        } else {
            onContinue();
        }
    }

    return (
        <div>
            <Component onContinue={handleContinue} />
        </div>
    )
}